const middleware = {}

middleware['metatag'] = require('../middleware/metatag.js')
middleware['metatag'] = middleware['metatag'].default || middleware['metatag']

middleware['trailingSlashRedirect'] = require('../middleware/trailingSlashRedirect.js')
middleware['trailingSlashRedirect'] = middleware['trailingSlashRedirect'].default || middleware['trailingSlashRedirect']

export default middleware
